import { Star } from 'lucide-react';

const VilleGoogleRating = () => (
  <section className="py-8 px-6 lg:px-8 bg-card border-y border-border/30">
    <div className="max-w-5xl mx-auto">
      <a
        href="https://maps.app.goo.gl/SPqj82CAvgbDAqUU6"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center justify-center gap-3 group"
      >
        <div className="flex gap-0.5">
          {Array.from({ length: 5 }).map((_, i) => (
            <Star key={i} size={18} className="fill-amber-400 text-amber-400" />
          ))}
        </div>
        <div>
          <span className="font-heading font-bold text-foreground text-lg">4,9</span>
          <span className="text-muted-foreground text-sm">/5</span>
          <span className="text-muted-foreground text-sm ml-1">— 32 avis Google</span>
        </div>
      </a>
    </div>
  </section>
);

export default VilleGoogleRating;
